import { Button } from "@chakra-ui/react";
import React from "react";
import { FaLinkedin } from "react-icons/fa";

export default function LinkedInButton({ size = "sm", width = "full" }) {
  const API_BASE = process.env.REACT_APP_API_URL || "https://localhost:7211";

  const handleLinkedInLogin = () => {
    // Redirect to backend LinkedIn OAuth endpoint
    window.location.href = `${API_BASE}/api/auth/linkedin`;
  };

  return (
    <Button
      leftIcon={<FaLinkedin />}
      bg="gray.600"
      color="white"
      size={size}
      w={width}
      onClick={handleLinkedInLogin}
      _hover={{
        bg: "gray.500",
      }}
      _active={{
        bg: "gray.700",
      }}
    >
      LinkedIn
    </Button>
  );
}
